import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ConsumptionMode } from 'services/consumptionMode/consumptionMode.type';
import { RootState } from '../store';

export const consumptionModeListSliceName = 'consumptionModeList';

export type ConsumptionModeListState = ConsumptionMode[];

const initialState: ConsumptionModeListState = [];

export const consumptionModeListSlice = createSlice<
    ConsumptionModeListState,
    SliceCaseReducers<ConsumptionModeListState>,
    string
>({
    name: consumptionModeListSliceName,
    initialState,
    reducers: {
        updateConsumptionModeList: (state, action: PayloadAction<ConsumptionModeListState>) =>
            action.payload,
    },
});

export const getConsumptionModeList = (state: RootState): ConsumptionModeListState =>
    state.consumptionModeList;

export const { updateConsumptionModeList } = consumptionModeListSlice.actions;
